module.exports = __webpack_public_path__ + "static/img/gp-community.c9e6e380.png";